module.exports = __webpack_public_path__ + "img/gb-whatsapp-update-failed-cover.3fa002b9.webp";